import { createContext, useContext, useReducer, type Dispatch, type ReactNode } from 'react';
import { bladeStackReducer, initialBladeStack } from './bladeStack';
import type { BladeAction, BladeStackState } from './types';

interface BladeStackValue {
  state: BladeStackState;
  dispatch: Dispatch<BladeAction>;
}

const BladeStackCtx = createContext<BladeStackValue | null>(null);

/** Provides the blade-stack state (context + the slice-1 reducer; no new state lib). */
export function BladeStackProvider({
  initial,
  children,
}: {
  initial?: BladeStackState;
  children: ReactNode;
}) {
  const [state, dispatch] = useReducer(bladeStackReducer, initial ?? initialBladeStack);
  return <BladeStackCtx.Provider value={{ state, dispatch }}>{children}</BladeStackCtx.Provider>;
}

export function useBladeStack(): BladeStackValue {
  const v = useContext(BladeStackCtx);
  if (!v) throw new Error('useBladeStack must be used within a BladeStackProvider');
  return v;
}
